jQuery(document).ajaxError(function(e, error) {
    if (error.statusText !== undefined && error.statusText == 'abort') {
        return;
    }
    if (error.status === 200) {
        return;
    }
    const message = error['responseText'];

    if (error.status === 403 && message.split('redirectTo":').length > 1) {
        const url = JSON.parse(message).redirectTo;
        window.open(url, "Connection", "width=800,height=600");
    }
    let hiddenError = false;
    if (message !== undefined && message.split('<!DOCTYPE html>').length > 1) {
        // Has html
        jQuery('body').append('<div class="error-wrapper">' + message + '</div>');
        jQuery('.error-wrapper').css({
            opacity: 0,
            position: 'fixed',
            height: '100vh',
            width: '100vw',
            left: 0,
            top: 0,
            'z-index': 100000
        });

        if (jQuery('.trace-head').length > 0) {
            var msg = jQuery('.trace-head').find('.trace-message').html().split('<br>');
            if (msg[1]) {
                var file = jQuery('.trace-details').find('tbody').find('tr:first').find('.trace-file-path').find('a').attr('title');
                var info = {
                    url: msg[1].split('Url: ')[1],
                    error: msg[2].split('VsError: ')[1],
                    file: file
                };
                var err = msg[2].split('VsError: ')[1].split(' (View:')[0];
                console.error(err);
                console.info('Error info: ',info);
            } else {
                hiddenError = true;
            }
        } else {
            console.error('Some error occurred. Check this page out with an admin-IP to see the error');
        }
        jQuery('.error-wrapper').remove();

    } else {
        console.log('Some error occurred', message);
    }

    if (!hiddenError) {
        setTimeout(function() {
            if (jQuery('.squde-flash').length === 0 && jQuery('.whoops-page').length === 0) {
                squde_flash('Er is een fout opgetreden.', 'alert');
            }
        },600);
    }

    jQuery('[data-is-loading]').doneLoading();
});